import { ofType } from "redux-observable";
import { from } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { selectRunningTournamentInfo } from "../../../selectors/selectTournamentInfo";
import { utilPersistence } from "../../../utils/utilPersistence";
import { actionActionButtonResetIteration } from "../../hud-action-button/actionHudActionButton";
import { IdActionButtonEntries } from "../../hud-action-button/IdActionButtonEntries";
import { actionPlayerLeagueSelectLeague } from "../../info/league/actionPlayerLeagueInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionTournament } from "../actionTournament";
import { IdTournamentPersistence } from "../IdTournamentPersistence";
export var epicTournamentSelectDialog = function (action$, state$) {
    return action$.pipe(ofType(TypeActionTournament.SelectTournamentDialog), filter(function () {
        var tournamentInfo = selectRunningTournamentInfo(state$.value);
        return tournamentInfo != undefined && tournamentInfo.balancing != undefined;
    }), switchMap(function () {
        var _a, _b;
        var tournamentInfo = selectRunningTournamentInfo(state$.value);
        var tournamentType = tournamentInfo.balancing.type;
        var lastCachedEvent = utilPersistence.getValue(IdPersistence.TournamentInfo, (_a = {},
            _a[IdTournamentPersistence.Confirmed] = true,
            _a[IdTournamentPersistence.LastTournament] = 0,
            _a));
        utilPersistence.setValue(IdPersistence.TournamentInfo, (_b = {},
            _b[IdTournamentPersistence.Confirmed] = true,
            _b[IdTournamentPersistence.LastTournament] = lastCachedEvent.LastTournament,
            _b));
        return from([
            actionActionButtonResetIteration(IdActionButtonEntries.PlayerLeagueStart),
            actionActionButtonResetIteration(IdActionButtonEntries.CoopLeagueStart),
            actionPlayerLeagueSelectLeague(tournamentType),
            actionModalOpen(IdModal.TournamentTent),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/epics/epicTournamentSelectDialog.ts
// module id = 2447
// module chunks = 3